import './CourseCategoryFilter.scss'

import { useEffect, useRef, createRef, useState } from 'react'
import Button from 'react-bootstrap/Button'
import cn from 'classnames'
import {
  EVENT_CATEGORY_COURSE,
  EVENT_ACTION_FILTER,
  saveUserEvent
} from 'components/common/api/UserEvents'

/**
 * Simple Course Filter component. Used to modify the courses displayed on the Course Discovery screen
 */
export default function CourseCategoryFilter({
  activeFilterIndex = 0,
  setActiveFilter,
  allCategories,
  categories,
  handleFilterChange
}) {
  const buttonRefs = useRef([])
  const [count, setCount] = useState(0)

  // Create a ref for each category, if we have them
  buttonRefs.current = Object.keys(categories)?.map(
    (element, index) => buttonRefs.current[index] ?? createRef()
  )

  const handleClick = (title, index) => {
    // Default to the 'All' category
    let matchingCategory = { name: 'All', id: 0, count: 0 }

    // If the index is greater than 0, we have a category
    if (index > 0) {
      // Find the matching category in the allCategories array
      matchingCategory = allCategories.find(category => category.name === title)

      // Return early if we don't have a matching category
      if (!matchingCategory) return
    }

    const totalCourseLength = handleFilterChange(matchingCategory)

    setActiveFilter(index)
    setCount(totalCourseLength?.length || 0)

    // Log filter action
    saveUserEvent(EVENT_CATEGORY_COURSE, EVENT_ACTION_FILTER, title)
  }

  useEffect(() => {}, [activeFilterIndex])

  return (
    categories && (
      <div className='scrolling-card-wrapper course-category-filter'>
        <div className='scrolling-card-cards'>
          {Object.keys(categories)?.map(
            (title, index) =>
              (categories[title]?.length > 0 || title === 'All') && (
                <Button
                  ref={buttonRefs.current[index]}
                  variant='secondary'
                  key={index}
                  className={cn(
                    'course-category-item d-inline-flex justify-content-between align-items-center px-3',
                    {
                      active: activeFilterIndex === index
                    }
                  )}
                  onClick={_ => handleClick(title, index)}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <span>{title}</span>

                  <span
                    className={cn('total-courses', {
                      show:
                        activeFilterIndex !== 0 &&
                        activeFilterIndex === index &&
                        count > 0
                    })}
                  >
                    {count}
                  </span>
                </Button>
              )
          )}
        </div>
      </div>
    )
  )
}
